@if (authService.isAuthenticated() && !hideLayout()) {
@if (authService.isStudent() || partnerEmbed.isEmbed() || funnel.isGuest()) {
<!-- Minimal layout for students, partner embeds and guest sessions (no sidebar/app nav) -->
<div class="layout w-100 h-100 overflow-auto" data-cy="pilot-layout">
  <router-outlet></router-outlet>
</div>
} @else {
<!-- Full layout for regular users -->
<div class="layout d-flex w-100 h-100" data-cy="main-layout">
  <editor-sidebar />
  <div class="h-100" [ngStyle]="{
          'margin-left': sidebarService.isSideBarCollapsed() ? '30px' : '270px',
          'width': 'calc(100vw - ' + (sidebarService.isSideBarCollapsed() ? '30' : '270') + 'px)',
          'transition': 'margin-left 300ms, width 300ms'
        }" data-cy="main-content">
    <router-outlet></router-outlet>
  </div>
  <!-- Floating Feedback Button (only for authenticated users) -->
  <app-feedback-button />
</div>
}
} @else {
@if (affiliateName()) {
<div class="affiliate-banner" role="status">
  @if (affiliateLabel()) {
  <span>🎉 {{ affiliateLabel() }}</span>
  } @else {
  <span>🎉 Dein <strong>10&nbsp;%-Rabatt</strong> über <strong>{{ affiliateName() }}</strong> ist aktiviert — er gilt
    dauerhaft auf alle Käufe und wird beim Bezahlen automatisch abgezogen.</span>
  }
  <button type="button" class="affiliate-banner-close" (click)="dismissAffiliateBanner()" aria-label="Hinweis schließen">
    &times;
  </button>
</div>
}
<router-outlet></router-outlet>
}
<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-circus"
  [fullScreen]="true"></ngx-spinner>